module.exports = __webpack_public_path__ + "img/no-image-slider.f4253f94.svg";